"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectPayoutNotificationRequestedV1 = exports.ConnectCompositionPageSchema = exports.ConnectMovementPageSchema = exports.ConnectPayoutPageSchema = exports.ConnectMovementSchema = exports.ConnectPayoutSchema = exports.ConnectBankDestinationSchema = exports.ConnectBalanceSchema = exports.ConnectedAccountScopeSchema = exports.ReceiptsSyncSchema = exports.ReceiptsSyncStatusSchema = void 0;
exports.connectPayoutNotificationId = connectPayoutNotificationId;
const zod_1 = require("zod");
const event_1 = require("./event");
exports.ReceiptsSyncStatusSchema = zod_1.z.enum(['pending', 'current', 'stale', 'unavailable']);
exports.ReceiptsSyncSchema = zod_1.z.object({
    lastSyncedAt: zod_1.z.string().datetime({ offset: true }).nullable(),
    syncStatus: exports.ReceiptsSyncStatusSchema,
});
exports.ConnectedAccountScopeSchema = zod_1.z.object({
    platformId: zod_1.z.string().min(1),
    accountId: zod_1.z.string().regex(/^acct_/),
    livemode: zod_1.z.boolean(),
});
exports.ConnectBalanceSchema = exports.ReceiptsSyncSchema.extend({
    account: exports.ConnectedAccountScopeSchema.nullable(),
    currency: zod_1.z.literal('BRL'),
    available: event_1.MonetaryValueSchema.nullable(),
    pending: event_1.MonetaryValueSchema.nullable(),
    reserve: event_1.MonetaryValueSchema.nullable(),
});
exports.ConnectBankDestinationSchema = zod_1.z.object({
    id: zod_1.z.string().min(1),
    bankName: zod_1.z.string().nullable(),
    last4: zod_1.z.string().max(4).nullable(),
}).nullable();
exports.ConnectPayoutSchema = zod_1.z.object({
    id: zod_1.z.string().regex(/^po_/),
    account: exports.ConnectedAccountScopeSchema,
    participant: zod_1.z.object({ id: zod_1.z.string(), name: zod_1.z.string().nullable(), email: zod_1.z.string().email().nullable().optional() }),
    amount: event_1.MonetaryValueSchema,
    currency: zod_1.z.literal('BRL'),
    status: zod_1.z.enum(['pending', 'in_transit', 'paid', 'failed', 'canceled']),
    createdAt: zod_1.z.string().datetime({ offset: true }),
    arrivalDate: zod_1.z.string().datetime({ offset: true }).nullable(),
    destination: exports.ConnectBankDestinationSchema,
    failure: zod_1.z.object({ code: zod_1.z.string().nullable(), message: zod_1.z.string().nullable() }).nullable(),
    compositionStatus: zod_1.z.enum(['pending', 'complete', 'unavailable', 'divergent']),
    ledgerStatus: zod_1.z.enum(['pending', 'completed', 'reversed']),
    ledgerPendingReason: zod_1.z.enum(['composition_pending', 'composition_divergent', 'allocation_or_eligibility_unproven']).nullable(),
}).merge(exports.ReceiptsSyncSchema);
exports.ConnectMovementSchema = zod_1.z.object({
    id: zod_1.z.string().regex(/^txn_/),
    account: exports.ConnectedAccountScopeSchema,
    amount: event_1.MonetaryValueSchema,
    fee: event_1.MonetaryValueSchema,
    net: event_1.MonetaryValueSchema,
    currency: zod_1.z.literal('BRL'),
    type: zod_1.z.string(),
    reportingCategory: zod_1.z.string().nullable(),
    status: zod_1.z.enum(['available', 'pending']),
    createdAt: zod_1.z.string().datetime({ offset: true }),
    availableOn: zod_1.z.string().datetime({ offset: true }).nullable(),
    sourceId: zod_1.z.string().nullable(),
    payoutId: zod_1.z.string().nullable(),
    saleIds: zod_1.z.array(zod_1.z.string()),
});
exports.ConnectPayoutPageSchema = exports.ReceiptsSyncSchema.extend({
    items: zod_1.z.array(exports.ConnectPayoutSchema), nextCursor: zod_1.z.string().nullable(), hasMore: zod_1.z.boolean(),
});
exports.ConnectMovementPageSchema = exports.ReceiptsSyncSchema.extend({
    items: zod_1.z.array(exports.ConnectMovementSchema), nextCursor: zod_1.z.string().nullable(), hasMore: zod_1.z.boolean(),
});
exports.ConnectCompositionPageSchema = exports.ConnectMovementPageSchema.extend({
    payoutId: zod_1.z.string(), compositionStatus: zod_1.z.enum(['pending', 'complete', 'unavailable', 'divergent']),
});
/** Provider facts for email only; these do not authorize ledger or accounting effects. */
exports.ConnectPayoutNotificationRequestedV1 = (0, event_1.defineEvent)({
    type: 'wallet.connect-payout.notification-requested',
    version: 1,
    payload: exports.ConnectedAccountScopeSchema.extend({
        userId: zod_1.z.string().min(1),
        payoutId: zod_1.z.string().regex(/^po_/),
        status: zod_1.z.enum(['paid', 'failed', 'canceled']),
        amount: event_1.MonetaryValueSchema.extend({ currency: zod_1.z.literal('BRL') }),
        observedAt: zod_1.z.string().datetime({ offset: true }),
    }).strict(),
});
function connectPayoutNotificationId(fact) {
    return `${exports.ConnectPayoutNotificationRequestedV1.type}:${[fact.platformId, fact.livemode ? 'live' : 'test', fact.accountId, fact.payoutId, fact.status].map(encodeURIComponent).join(':')}`;
}
//# sourceMappingURL=connect-receipts.js.map